import { useAppDispatch, useAppSelector } from "app/hooks"
import { deleteRecentIngredient } from "../foodSlice"
import { useFailed, useSuccess } from "features/notification/hooks"

export const useDeleteRecentIngredient = (callback?: () => void) => {
  const deleteRecentIngredientLoading = useAppSelector(
    (state) => state.food.deleteRecentIngredientLoading,
  )
  const deleteRecentIngredientSuccess = useAppSelector(
    (state) => state.food.deleteRecentIngredientSuccess,
  )
  const deleteRecentIngredientFailed = useAppSelector(
    (state) => state.food.deleteRecentIngredientFailed,
  )

  const dispatch = useAppDispatch()

  const handleDeleteRecentIngredient = (id: string) => {
    dispatch(deleteRecentIngredient(id))
  }

  useFailed(deleteRecentIngredientFailed)
  useSuccess(deleteRecentIngredientSuccess, { message: "" }, callback)

  return {
    deleteRecentIngredientLoading,
    handleDeleteRecentIngredient,
  }
}
